export { default as DefaultPage } from './DefaultPage';



// WEBPACK FOOTER //
// ./src/features/register/index.js